import { createFileRoute } from "@tanstack/react-router"
import { UnauthenticatedLayout } from "@/components"

export const Route = createFileRoute("/_unauthenticated")({
  component: UnauthenticatedLayout,
})
